import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { DEFAULT_LOCALE } from '../../../../../components/PriceOverviewCard/models.js';
import { Flex, HelpTooltip, LabelSmallBold, ParagraphSmall } from '../../../../../primitives/index.js';
import { priceFormatter } from '../../../../../utils/index.js';
export const PriceCacheTooltip = ({
  locale = DEFAULT_LOCALE,
  totalPriceCurrency,
  priceCache
}) => {
  const {
    t
  } = useTranslation();
  const headerText = locale === 'de-CH' ? t('priceOverviewCard:tripPrice.tooltip.CHFHeader', {
    priceDifference: priceFormatter(locale, totalPriceCurrency).format((priceCache?.localPrices?.priceDifference.amount ?? 0) / 100),
    euroDifference: priceFormatter('de-DE', 'EUR').format((priceCache?.priceDifference ?? 0) / 100)
  }) : t('priceOverviewCard:tripPrice.tooltip.header', {
    priceDifference: priceFormatter(locale, totalPriceCurrency).format((priceCache?.priceDifference ?? 0) / 100)
  });
  return _jsx(HelpTooltip, {
    tooltipText: t('priceOverviewCard:tripPrice.tooltip.text'),
    content: _jsxs(Flex, {
      gap: "global/medium",
      children: [_jsx(LabelSmallBold, {
        children: headerText
      }), _jsx(ParagraphSmall, {
        children: t('priceOverviewCard:tripPrice.tooltip.text')
      })]
    })
  });
};